import React from "react";
import { ReactComponent as TrainIcon } from "../../assets/icons/train-icon.svg";
import { ReactComponent as PrepareIcon } from "../../assets/icons/prepare-icon.svg";
import { ReactComponent as PartnerIcon } from "../../assets/icons/partner-icon.svg";
import { ReactComponent as MentorIcon } from "../../assets/icons/mentor-icon.svg";
import { useCustomRouter } from "../../hooks/useCustomRouter";
import {
  Section,
  SectionHeading,
  PillarsRow,
  Pillar,
  PillarHeader,
  PillarIcon,
  PillarTitle,
  PillarBody,
  PillarLink,
  pillarColors
} from "./styled.components";

const pillars = [
  {
    icon: <TrainIcon />,
    color: pillarColors.blue,
    title: "Train",
    body: "Free food allergy education for schools, food service teams, and communities.",
    linkLabel: "Explore Trainings →",
    path: "trainings"
  },
  {
    icon: <PrepareIcon />,
    color: pillarColors.purple,
    title: "Prepare",
    body: "Practical emergency resources that help people recognize symptoms and respond quickly.",
    linkLabel: "View Resources →",
    path: "get-involved"
  },
  {
    icon: <PartnerIcon />,
    color: pillarColors.green,
    title: "Partner",
    body: "Collaborations with schools, healthcare leaders, public health agencies, and community organizations.",
    linkLabel: "Partner With Us →",
    path: "about-us/collaborators"
  },
  {
    icon: <MentorIcon />,
    color: pillarColors.darkBlue,
    title: "Mentor",
    body: "Connecting the next generation of public health leaders with meaningful experience in food allergy advocacy.",
    linkLabel: "Learn More →",
    path: "get-involved/internships-and-volunteers"
  }
];

const HowWeCreateChange: React.FC = () => {
  const customRouter = useCustomRouter();
  return (
    <Section>
      <SectionHeading>How We Create Change</SectionHeading>
      <PillarsRow>
        {pillars.map((p, i) => (
          <Pillar key={i}>
            <PillarHeader>
              <PillarIcon color={p.color}>{p.icon}</PillarIcon>
              <PillarTitle color={p.color}>{p.title}</PillarTitle>
            </PillarHeader>
            <PillarBody>{p.body}</PillarBody>
            <PillarLink
              color={p.color}
              onClick={() => customRouter.append(p.path)}
            >
              {p.linkLabel}
            </PillarLink>
          </Pillar>
        ))}
      </PillarsRow>
    </Section>
  );
};

export default HowWeCreateChange;
